import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-风险模型",
  "use": "icon-风险模型-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-风险模型\">\r\n<g>\r\n\t<path d=\"M177.4,51.6l-74-42.7c-2-1.2-4.6-1.2-6.7,0L22.7,51.6c-2,1.2-3.3,3.4-3.3,5.7v85.4c0,2.4,1.3,4.6,3.3,5.7l73.9,42.7\r\n\t\tc2,1.2,4.6,1.2,6.7,0l73.9-42.7c2-1.2,3.3-3.4,3.3-5.7V57.3C180.7,55,179.4,52.8,177.4,51.6z M167.3,137.9c0,0.6-0.3,1.2-0.9,1.5\r\n\t\tl-65.6,37.9c-0.5,0.3-1.2,0.3-1.6,0l-65.6-37.9c-0.5-0.3-0.9-0.9-0.9-1.5V62.2c0-0.6,0.3-1.2,0.9-1.5l65.6-37.9\r\n\t\tc0.5-0.3,1.2-0.3,1.6,0l65.6,37.9c0.5,0.3,0.9,0.9,0.9,1.5V137.9z\" />\r\n\t<path d=\"M151.2,63.6L99.9,93.2L49,63.8l0,0c-3.2-1.8-7.3-0.8-9.1,2.4l0,0c-1.8,3.2-0.8,7.3,2.4,9.1l51.2,29.6v58.2\r\n\t\tc0,3.7,3,6.7,6.7,6.7c3.7,0,6.7-3,6.7-6.7v-58.4l51.1-29.5c3.2-1.8,4.3-5.9,2.4-9.1C158.4,62.9,154.3,61.9,151.2,63.6z\" />\r\n</g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/风险模型.svg
// module id = uaFO
// module chunks = 15